import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Grid,
  Container,
  Alert
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  getDateToString
} from 'src/utils/date';
import { useLocation, useHistory, useParams, useNavigate } from 'react-router-dom';
import { OBJECT_TYPES, RESOLUTION, USER_ROLES } from 'src/constants';
import SummaryChart from './SummaryChart';
import ColdWaterConsumption from './Components/ColdWaterConsumption';
import HotWaterConsumption from './Components/HotWaterConsumption';
import ElectricityConsumption from './Components/ElectricityConsumption';
import HeatenergyConsumption from './Components/HeatenergyConsumption';
import EVChargingConsumption from './Components/EVChargingConsumption';
import 'moment/locale/sv';
import SummaryTable from './SummaryTable';
import DelayedSpinner from 'src/components/DelayedSpinner';
import { useMemo } from 'react';
import authService from 'src/services/authService';
import DateScrubber from 'src/components/DateScrubber';
import StatisticsButton from 'src/components/StatisticsButton';
import { useSelector } from 'react-redux';
import ApartmentSummaryTab from './ApartmentSummaryTab';
import Header from './Header';
import Navbar from './Navbar';
import Footer from './Footer';
import { ConsumptionContext } from './Components/ConsumptionContext';
import axios from 'src/utils/axios';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 300,
      paddingTop: 64
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
    position: 'relative'
  }
}));

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function CustomerView({ children }) {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const location = useLocation();

  //const { denotation } = useParams();
  const { denotation, encFlat, encCustomer } = useParams();
  const isEncrypted = !!encFlat && !!encCustomer;
  const [consumption, setConsumption] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const { user } = useSelector(state => state.account);

  const navigate = useNavigate();

  const query = useQuery();
  const queryFromdate = query.get('from');
  const queryTodate = query.get('to');
  const queryResolution = query.get('res');

  const path = '/workers/worker.js';
  const temperatureWorker = useMemo(() => new Worker(path), [path]);

  useEffect(() => {
    temperatureWorker.onmessage = ({ data }) => {
      if (data.error) {
        if (data.status === 403) {
          navigate('/403');
        }
        setIsFetching(false);
        return;
      }

      const [consumptionData, tableData] = data.map(d => JSON.parse(d));
      setConsumption(consumptionData);
      setTableData(tableData);
      setIsFetching(false);
    };

    return () => temperatureWorker.terminate();
  }, [temperatureWorker]);

  const fetch = useCallback(() => {
    if (queryFromdate && queryTodate) {
      const type = OBJECT_TYPES.APARTMENT;
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      //const url = `${baseUrl}/api/metering/customerconsumption/forcustomer/${denotation}/${queryFromdate}/${queryTodate}/${queryResolution}`;
      //const tableUrl = `${baseUrl}/api/metering/customerconsumption/apartmentreadings/forcustomer/${denotation}/${queryFromdate}/${queryTodate}/0`;

      let url = '';

      if (isEncrypted) {
        url = `${baseUrl}/api/metering/customerconsumption/forcustomer/encrypted/${encFlat}/${encCustomer}/${queryFromdate}/${queryTodate}/${queryResolution}`;
      } else {
        // Okrypterad
        url = `${baseUrl}/api/metering/customerconsumption/forcustomer/${denotation}/${queryFromdate}/${queryTodate}/${queryResolution}`;
      }

      temperatureWorker.postMessage({
        message: 'multi-fetch',
        payload: { urls: [url/*, tableUrl*/], token: authService.getAccessToken() }
      });
      setIsFetching(true);
    }
  }, [queryFromdate, queryTodate]);

  const logLogin = async () => {
    try {
        const baseUrl = process.env.REACT_APP_API_BASE_URL;
        let url = '';

        if (isEncrypted) {
          url = `${baseUrl}/api/customerloginlog/loglogin/encrypted/${encFlat}/${encCustomer}`;
        } else {
          // Okrypterad
          url = `${baseUrl}/api/customerloginlog/loglogin/${denotation}`;
        }
        /*const response = await axios.get(
        `${baseUrl}/api/customerloginlog/loglogin/${denotation}`
        );*/

        const response = await axios.get(
        url
        );

    } catch (error) {
        console.error("Fel vid GET-förfrågan:", error);
    } finally {
    }
  };

  useEffect(() => {
    fetch();
  }, [fetch]);
 
  useEffect(() => {
    logLogin();
  }, []);

  useEffect(() => {
    //console.log(consumption);
  }, [consumption]);

  return (
    <ConsumptionContext.Provider value={consumption}>
        <div className={classes.root}>
        <Header onMobileNavOpen={() => setMobileNavOpen(true)} />
        <Navbar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
        consumption={consumption}
        />
        <div className={classes.wrapper}>
            <div className={classes.contentContainer}>
            <div className={classes.content}>
                {consumption?.shownMessage && (
                <Box mt={2} mr={2} ml={2}>
                    <Alert severity="info" variant="filled">
                    {consumption.shownMessage}
                    </Alert>
                </Box>
                )}
                {(!location?.pathname?.includes("advices") && !location?.pathname?.includes("changepassword") && !location?.pathname?.includes("support")) &&
                <Box mr={3} ml={3} mt={2}>
                <DateScrubber key={consumption?.moveInDate || 'initial'} fromDate={queryFromdate} customerView={true} moveInDate={consumption?.moveInDate} />
                </Box>
                }
                {children}
            </div>
            </div>
        </div>
        </div>
    </ConsumptionContext.Provider>
  );
}

CustomerView.propTypes = {
    children: PropTypes.any
};

export default CustomerView;
